import { forwardRef } from 'react'
import type { HTMLAttributes } from 'react'
import type { RecipeVariants } from '@vanilla-extract/recipes'
import { cx } from '@shared/lib/cx'
import { card } from './Card.css'

type CardVariants = NonNullable<RecipeVariants<typeof card>>

export type CardProps = HTMLAttributes<HTMLDivElement> & CardVariants

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padding, interactive, className, children, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cx(card({ padding, interactive }), className)} {...rest}>
      {children}
    </div>
  )
})
